import { render, staticRenderFns } from "./AssigmentsNeedReferences.vue?vue&type=template&id=004b8a44"
import script from "./AssigmentsNeedReferences.vue?vue&type=script&lang=js"
export * from "./AssigmentsNeedReferences.vue?vue&type=script&lang=js"
import style0 from "./AssigmentsNeedReferences.vue?vue&type=style&index=0&id=004b8a44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports